// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3us55","buttons":"styles_buttons__2phsk"};